module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-x-8"
  }, [_c('div', [_c('div', {
    staticClass: "border-b pb-6 pt-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-800"
  }, [_vm._v("Automatic Turns")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:auto-turn-info.right",
      arg: "auto-turn-info",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-gray-600 px-2"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Automatically move the next tapped-in student to the speaker position.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.auto_turn),
      callback: function($$v) {
        _vm.auto_turn = $$v
      },
      expression: "auto_turn"
    }
  })], 1)]), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "auto-turn-info",
      "width": 380
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n          Parlay will automatically add the next tapped in student into the\n          speaker position after the current speaker taps out, or if the\n          current speaker position is empty. Teachers can still manage the\n          order of speakers using the queue.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "py-7 border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins"
  }, [_vm._v("Audio / Video")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:audio-video-info.right",
      arg: "audio-video-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-gray-600"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Embedded audio/video functionality for remote RoundTables. Not required for transcription.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "value": _vm.audio_video,
      "labels": false,
      "sync": true,
      "color": "#72ccd7"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeAudioVideo($event)
      }
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "audio-video-info",
      "width": 400
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n            All users should have a working camera and a microphone for this\n            functionality, but can turn off video and mute audio as desired.\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7 border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_vm._m(0), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "value": _vm.is_transcription_active,
      "labels": false,
      "sync": true,
      "color": "#72ccd7"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeTranscription($event)
      }
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "audio-video-info",
      "width": 400
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n            All users should have a working camera and a microphone for this\n            functionality, but can turn off video and mute audio as desired.\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins"
  }, [_vm._v("Assessment")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:assessment-info.right",
      arg: "assessment-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-gray-600"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Teacher can assess students based on predefined criteria.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.assessment_status),
      callback: function($$v) {
        _vm.assessment_status = $$v
      },
      expression: "assessment_status"
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "assessment-info",
      "width": 350
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n            Create your own criteria or use one of the defaults. Set a Max\n            Score for a rubric-style assessment, or leave it off for a\n            tally-based approach.\n          ")])]), _vm._v(" "), (_vm.assessment_status) ? _c('div', {
    staticClass: "mt-4 pl-2.5"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row"
  }, [_c('div', {
    staticClass: "bg-gray-100 border border-solid border-gray-200 text-gray-500 rounded p-0.5 max-w-xxs"
  }, [_c('button', {
    staticClass: "w-16 py-1 rounded font-poppins",
    class: _vm.max_score_enabled === false ? 'bg-white border border-solid border-gray-200' : '',
    on: {
      "click": function($event) {
        _vm.max_score_enabled = !_vm.max_score_enabled
      }
    }
  }, [_vm._v("\n                Tally\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "w-16 py-1 rounded font-poppins",
    class: _vm.max_score_enabled === true ? 'bg-white border border-solid border-gray-200' : '',
    on: {
      "click": function($event) {
        _vm.max_score_enabled = !_vm.max_score_enabled
      }
    }
  }, [_vm._v("\n                Rubric\n              ")])]), _vm._v(" "), (_vm.max_score_enabled) ? _c('div', {
    staticClass: "flex items-center mt-1 sm:mt-0 sm:ml-5"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ml-5 flex items-center space-x-1"
  }, [_c('button', {
    staticClass: "text-gray-500 h-7 w-7 rounded-full hover:bg-gray-100",
    attrs: {
      "disabled": Number(_vm.point_scale) === 0
    },
    on: {
      "click": function($event) {
        _vm.point_scale -= 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left text-xs"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.point_scale),
      expression: "point_scale"
    }],
    staticClass: "w-10 h-8 rounded text-center custom-border",
    attrs: {
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.point_scale)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.point_scale = $event.target.value
      }, _vm.inputed]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "text-gray-500 h-7 w-7 rounded-full hover:bg-gray-100",
    on: {
      "click": _vm.addPoint
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right text-xs"
  })])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.available_point_types), function(point_type, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "flex justify-between border border-solid border-gray-200 py-2.5 px-4 rounded hover:shadow-sm"
    }, [_c('div', {
      staticClass: "flex items-center space-x-3 w-9/12"
    }, [_c('Popper', {
      attrs: {
        "append-to-body": true,
        "prevent-default": true,
        "trigger": "clickToToggle",
        "options": {
          placement: 'right',
          modifiers: {
            offset: {
              offset: '0,8px'
            }
          }
        }
      },
      on: {
        "show": _vm.openPopper,
        "hide": _vm.closePopper
      }
    }, [_c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: (_vm.closePopper),
        expression: "closePopper"
      }],
      staticClass: "popper bg-white rounded-md shadow-sm relative w-64 pb-4"
    }, [_c('div', {
      staticClass: "py-2.5 font-semibold text-sm font-poppins text-left w-full px-3"
    }, [_vm._v("\n                      " + _vm._s(point_type.title) + "\n                    ")]), _vm._v(" "), (point_type.description) ? _c('div', {
      staticClass: "text-left text-xs flex flex-col px-3 text-gray-700 font-poppins font-light"
    }, [_c('div', {
      staticClass: "html-content font-poppins font-light",
      domProps: {
        "innerHTML": _vm._s(typeof point_type.description === 'object' ? point_type.description.join('. ') : point_type.description)
      }
    })]) : _vm._e(), _vm._v(" "), (point_type.points_description && point_type.points_description.length > 0) ? _c('div', {
      staticClass: "mt-4 px-3"
    }, _vm._l((point_type.points_description), function(point) {
      return _c('div', {
        staticClass: "flex flex-col text-left text-xs space-y-2"
      }, [(point.description !== '') ? _c('div', {
        staticClass: "flex items-center space-x-1 mb-2"
      }, [_c('div', {}, [_c('span', {
        staticClass: "font-semibold font-poppins text-gray-800"
      }, [_vm._v("(" + _vm._s(point.value) + ") Level: ")]), _c('span', {
        staticClass: "text-gray-700"
      }, [_vm._v(_vm._s(point.description))])])]) : _vm._e()])
    }), 0) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "h-full items-center font-semibold hover:underline font-poppins text-gray-600 hover:text-gray-700",
      attrs: {
        "slot": "reference",
        "type": "button"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa-solid fa-circle-info"
    })])]), _vm._v(" "), _c('button', {
      staticClass: "text-sm hover:underline",
      on: {
        "click": function($event) {
          return _vm.editAssessmentPoint(point_type)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(point_type.title) + "\n                ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_points),
        expression: "selected_points"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": point_type.tag,
        "checked": Array.isArray(_vm.selected_points) ? _vm._i(_vm.selected_points, point_type.tag) > -1 : (_vm.selected_points)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected_points,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = point_type.tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected_points = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected_points = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_points = $$c
          }
        }
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "w-full flex items-center space-x-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.point_title),
      expression: "point_title"
    }],
    staticClass: "px-4 py-2 w-full rounded-t placeholder-gray-500 bg-white border border-solid border-gray-200",
    attrs: {
      "type": "text",
      "placeholder": "Enter a new criteria title..."
    },
    domProps: {
      "value": (_vm.point_title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveNewPoint.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.point_title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-700 sample rounded text-white px-3 py-1.5 border border-solid border-blueGray-700 disabled:opacity-50",
    attrs: {
      "disabled": _vm.point_title === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.saveNewPoint()
      }
    }
  }, [_vm._v("\n                Add\n              ")])])])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex justify-between items-start pt-3"
  }, [_c('div', [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins"
  }, [_vm._v("Sentence Stems")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:sentence-info.left",
      arg: "sentence-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "px-2"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-gray-600"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n            Students can click use these sentence stems to help frame their\n            contributions to the discussion.\n          ")])]), _vm._v(" "), _c('div', [_c('pl-menu', {
    attrs: {
      "menuSize": 1,
      "direction": "right"
    }
  }, [_c('button', {
    staticClass: "rounded",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('country-flag', {
    staticClass: "rounded-full",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "country": _vm.language,
      "size": "normal",
      "rounded": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hover:bg-gray-100 w-6 h-6 rounded-full text-xs border border-solid border-gray-200"
  }, [_c('i', {
    staticClass: "fa fa-chevron-down items-center text-gray-700 py-auto"
  })])], 1)]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, _vm._l((_vm.countries_list), function(country) {
    return _c('li', {
      key: country.lang,
      staticClass: "menu-option",
      on: {
        "click": function($event) {
          return _vm.changeLanguage(country.lang)
        }
      }
    }, [_c('span', [_c('country-flag', {
      staticStyle: {
        "margin-left": "-15px"
      },
      attrs: {
        "country": country.lang,
        "size": "normal",
        "rounded": ""
      }
    })], 1)])
  }), 0)])], 1)]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "sentence-info",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4 font-semibold border-b"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n          Clicking on a sentence stem will auto-populate the text into the\n          student notepad, where they can fill it out and reference it during\n          their turn.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "font-semibold text-primary"
  }, [_c('i', {
    staticClass: "fas fa-play mr-1"
  }), _vm._v("\n          " + _vm._s(_vm.$t('new_idea')) + "\n        ")]), _vm._v(" "), _vm._l((_vm.new_idea_sentences), function(newidea, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4 flex justify-between"
    }, [_c('span', {
      staticClass: "w-10/12 text-sm"
    }, [_vm._v("\n            " + _vm._s(index + 1) + ".\n            "), (newidea.is_custom) ? _c('span', [_vm._v(" " + _vm._s(newidea.sentence) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('stem_new_' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [(newidea.is_custom) ? _c('i', {
      staticClass: "fas fa-trash-alt mr-1.5 text-red-200 hover:text-red-700 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteNewIdeaModal(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (newidea.is_custom) ? _c('i', {
      staticClass: "fas fa-edit mr-1.5 text-gray-200 hover:text-gray-500 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.editNewIdeaSentence(index, newidea)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (newidea.is_active),
        expression: "newidea.is_active"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(newidea.is_active) ? _vm._i(newidea.is_active, null) > -1 : (newidea.is_active)
      },
      on: {
        "change": function($event) {
          var $$a = newidea.is_active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(newidea, "is_active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(newidea, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(newidea, "is_active", $$c)
          }
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_idea_new),
      expression: "new_idea_new"
    }],
    staticClass: "px-4 py-2 w-full rounded placeholder-gray-500 bg-white border border-solid border-gray-200",
    attrs: {
      "type": "text",
      "placeholder": 'Enter a new question...',
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.new_idea_new)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewIdeaSentence.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_idea_new = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing_new_idea_sentence) ? _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "h-8 w-12 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.cancelEditNewIdeaSentence
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "h-8 w-12 bg-primary text-white rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.saveEditNewIdeaSentence
    }
  }, [_vm._v("\n              Save\n            ")])]) : _c('button', {
    staticClass: "outline-none",
    on: {
      "click": _vm.addNewIdeaSentence
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle text-2xl ml-3 text-gray-400"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-6"
  }, [_c('p', {
    staticClass: "font-semibold text-green-600"
  }, [_c('i', {
    staticClass: "fas fa-square mr-1"
  }), _vm._v(_vm._s(_vm.$t('build_on')) + "\n        ")]), _vm._v(" "), _vm._l((_vm.build_on_sentences), function(build_on, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4 flex justify-between"
    }, [_c('span', {
      staticClass: "w-10/12 text-sm"
    }, [_vm._v(_vm._s(index + 1) + ".\n            "), (build_on.is_custom) ? _c('span', [_vm._v(_vm._s(build_on.sentence) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('stem_build_' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [(build_on.is_custom) ? _c('i', {
      staticClass: "fas fa-trash-alt mr-1.5 text-red-200 hover:text-red-700 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteBuilOnModal(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (build_on.is_custom) ? _c('i', {
      staticClass: "fas fa-edit mr-1.5 text-gray-200 hover:text-gray-500 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.editBuilOnSentence(index, build_on)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (build_on.is_active),
        expression: "build_on.is_active"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(build_on.is_active) ? _vm._i(build_on.is_active, null) > -1 : (build_on.is_active)
      },
      on: {
        "change": function($event) {
          var $$a = build_on.is_active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(build_on, "is_active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(build_on, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(build_on, "is_active", $$c)
          }
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.build_on_new),
      expression: "build_on_new"
    }],
    staticClass: "px-4 py-2 w-full rounded placeholder-gray-500 bg-white border border-solid border-gray-200",
    attrs: {
      "type": "text",
      "placeholder": 'Enter a new question...',
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.build_on_new)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addBuildOnSentence.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.build_on_new = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing_build_on_sentence) ? _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "h-8 w-12 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.cancelEditBuildOnSentence
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "h-8 w-12 bg-primary text-white rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.saveEditBuildOnSentence
    }
  }, [_vm._v("\n              Save\n            ")])]) : _c('button', {
    staticClass: "outline-none",
    on: {
      "click": _vm.addBuildOnSentence
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle text-2xl ml-3 text-gray-400"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-6"
  }, [_c('p', {
    staticClass: "font-semibold text-pinky"
  }, [_c('i', {
    staticClass: "fas fa-circle mr-1"
  }), _vm._v(_vm._s(_vm.$t('challenge')) + "\n        ")]), _vm._v(" "), _vm._l((_vm.challenge_sentences), function(challenge, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4 flex justify-between"
    }, [_c('span', {
      staticClass: "w-10/12 text-sm"
    }, [_vm._v(_vm._s(index + 1) + ".\n            "), (challenge.is_custom) ? _c('span', [_vm._v(_vm._s(challenge.sentence))]) : _c('span', [_vm._v(_vm._s(_vm.$t('stem_challenge_' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [(challenge.is_custom) ? _c('i', {
      staticClass: "fas fa-trash-alt mr-1.5 text-red-200 hover:text-red-700 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteChallengeModal(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (challenge.is_custom) ? _c('i', {
      staticClass: "fas fa-edit mr-1.5 text-gray-200 hover:text-gray-500 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.editChallengeSentence(index, challenge)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (challenge.is_active),
        expression: "challenge.is_active"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(challenge.is_active) ? _vm._i(challenge.is_active, null) > -1 : (challenge.is_active)
      },
      on: {
        "change": function($event) {
          var $$a = challenge.is_active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(challenge, "is_active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(challenge, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(challenge, "is_active", $$c)
          }
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.challenge_new),
      expression: "challenge_new"
    }],
    staticClass: "px-4 py-2 w-full rounded placeholder-gray-500 bg-white border border-solid border-gray-200",
    attrs: {
      "type": "text",
      "placeholder": 'Enter a new question...',
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.challenge_new)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addChallengeSentence.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.challenge_new = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing_challenge_sentence) ? _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "h-8 w-12 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.cancelEditChallengeSentence
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "h-8 w-12 bg-primary text-white rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.saveEditChallengeSentence
    }
  }, [_vm._v("\n              Save\n            ")])]) : _c('button', {
    staticClass: "outline-none",
    on: {
      "click": _vm.addChallengeSentence
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle text-2xl ml-3 text-gray-400"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-6"
  }, [_c('p', {
    staticClass: "flex font-semibold text-darkBlue-dark"
  }, [_c('img', {
    staticClass: "h-5 w-5 mr-1",
    attrs: {
      "src": "/static/live_discussion/ld_question_icon.svg"
    }
  }), _vm._v(_vm._s(_vm.$t('question')) + "\n        ")]), _vm._v(" "), _vm._l((_vm.question_sentences), function(question, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4 flex justify-between"
    }, [_c('span', {
      staticClass: "w-10/12 text-sm"
    }, [_vm._v(_vm._s(index + 1) + ".\n            "), (question.is_custom) ? _c('span', [_vm._v(_vm._s(question.sentence))]) : _c('span', [_vm._v(_vm._s(_vm.$t('stem_question_' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [(question.is_custom) ? _c('i', {
      staticClass: "fas fa-trash-alt mr-1.5 text-red-200 hover:text-red-700 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteQuestionModal(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.is_custom) ? _c('i', {
      staticClass: "fas fa-edit mr-1.5 text-gray-200 hover:text-gray-500 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.editQuestionSentence(index, question)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.is_active),
        expression: "question.is_active"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(question.is_active) ? _vm._i(question.is_active, null) > -1 : (question.is_active)
      },
      on: {
        "change": function($event) {
          var $$a = question.is_active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(question, "is_active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(question, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(question, "is_active", $$c)
          }
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question_new),
      expression: "question_new"
    }],
    staticClass: "px-4 py-2 w-full rounded placeholder-gray-500 bg-white border border-solid border-gray-200",
    attrs: {
      "type": "text",
      "placeholder": 'Enter a new question...',
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.question_new)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addQuestionSentence.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question_new = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing_question_sentence) ? _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "h-8 w-12 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.cancelEditQuestionSentence
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "h-8 w-12 bg-primary text-white rounded-sm ml-2 outline-none",
    on: {
      "click": _vm.saveEditQuestionSentence
    }
  }, [_vm._v("\n              Save\n            ")])]) : _c('button', {
    staticClass: "outline-none",
    on: {
      "click": _vm.addQuestionSentence
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle text-2xl ml-3 text-gray-400"
  })])])], 2)], 1)]), _vm._v(" "), (_vm.show_delete_new_idea_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "optionalText": "New Idea"
    },
    on: {
      "close": _vm.closeDeleteModal,
      "actionConfirmed": _vm.removeNewIdeaSentence
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_build_on_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "optionalText": "Build On"
    },
    on: {
      "close": _vm.closeDeleteModal,
      "actionConfirmed": _vm.removeBuildOnSentence
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_challenge_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "optionalText": "Challenge"
    },
    on: {
      "close": _vm.closeDeleteModal,
      "actionConfirmed": _vm.removeChallengeSentence
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_questions_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "optionalText": "Question"
    },
    on: {
      "close": _vm.closeDeleteModal,
      "actionConfirmed": _vm.removeQuestionSentence
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-1 py-1"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', {
    staticClass: "text-base font-semibold font-poppins"
  }, [_vm._v("Transcription")]), _vm._v(" "), _c('div', {
    staticClass: "px-2.5 flex items-center space-x-1 font-poppins py-0.5 bg-pink-50 text-xs border border-solid border-pinky rounded-full text-pinky font-semibold"
  }, [_c('span', [_vm._v("BETA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Create a turn by turn transcript from the discussion that can be analyzed by genie.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "text-sm font-semibold font-poppins"
  }, [_vm._v("Max Score")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500 text-xs font-poppins"
  }, [_vm._v("For each criteria")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-47a63624!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/LDSettingsTab.vue
// module id = 1753
// module chunks = 61